import React from 'react';
import { Col, Row } from 'reactstrap';
import { ReactComponent as DoSelectBadBot } from '../../../assets/svg/images/doselect_bad_bot.svg';
import Button from '../Buttons/Button';
import styles from './ErrorBoundary.module.css';

const ErrorBoundary: React.FC = () => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className={styles.errorBoundaryContainer}>
      <div className={styles.errorBoundaryCard}>
        <Row className={styles.errorBoundaryRow}>
          <Col>
            <DoSelectBadBot className={styles.errorBoundaryImage} />
          </Col>
          <Col className="d-flex flex-column text-center">
            <h1 className={styles.title}>Drats! Something&apos;s wrong.</h1>
            <p className={styles.message}>
              Something went wrong, Try to refresh the page. If issue still
              persists, please contact <strong>support@doselect.com</strong>
            </p>
            <Button
              color="primary"
              className="text-uppercase"
              onClick={handleReload}
            >
              Reload
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ErrorBoundary;
